import React from "react";
import { company } from "../mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="section-dark">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-serif-display text-xl text-[#dde3d0]">
              {company.shortName} <span className="italic-accent">{company.suffix}</span>
            </p>
            <p className="mt-4 text-[#8ea27a] text-sm max-w-sm leading-relaxed">
              An owner-side property consultancy for private international owners. Independent by structure, analytical by habit, remote by design.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow" style={{ color: "#a9b891" }}>Contact</p>
            <ul className="mt-4 space-y-2 text-sm text-[#a9b891]">
              <li><a href={`mailto:${company.email}`} className="link-underline">{company.email}</a></li>
              <li><a href={`tel:${company.phoneHref}`} className="link-underline">{company.phone}</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow" style={{ color: "#a9b891" }}>Registered Office</p>
            <p className="mt-4 text-sm text-[#a9b891] leading-relaxed">
              {company.address.line1}<br />{company.address.line2}
            </p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#3a4234] flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#8ea27a]">
          <p>© {year} {company.name}. All rights reserved.</p>
          <p>Registered in {company.registered} · Anchored in {company.anchor}</p>
        </div>
      </div>
    </footer>
  );
}
